export default __webpack_public_path__ + "static/media/emotion-l@3x.9b3f10d1.png";